import { Component, OnInit , OnDestroy} from '@angular/core';
import { BuildingsService } from '../../service/buildings.service';
import { DocumentService } from "../../service/document.service"
import { HttpService } from "../../service/http.service"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit,OnDestroy {

  id = localStorage.getItem('residents');
  buildArray= [];
  document: FormGroup;
  fileList: FileList;
  file: File = null;
  fileName = null;
  buildings;
  filePreview;
  buildingArray =[]
  buildingNames=[]
  buildNameArray=[]
  names='';
  editedNames='';
    //-------------
  fileError = null;
  fileValidError = null;
  DescriptionError = null;
  titleError = null;
  titleSpaceError = null;
  DescriptionSpaceError = null;
  successMessage = null;

  documentList = [];
  fileChanged: boolean = false;
  formState: boolean = true;
  documentId = null;
  buildingCheckboxState: boolean = false;
  buildingList = [];

  isManager = localStorage.getItem('isManager');
  fileToImage;

  test = 'data:application/pdf;base64,'
  isDocument;
  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  documentPath = null;
  isUpdated = false;
  fileToDelete = '';
  fileId;
  deleteButtonDisable = false;
  documentFilterCriteria = "All Building";
  buildFilter = [];
  isLoadingActive: boolean = false;
  documentCount = 0;

  constructor(private building: BuildingsService,
              private fb: FormBuilder,
              private documentService: DocumentService,
              private httpService: HttpService) { }

  ngOnInit() {

    this.document = this.fb.group({
      title               : ['', Validators.compose([Validators.required])],
      description         : ['', Validators.compose([Validators.required])],
    })

    this.building.getAllBuildingsByUserId(this.id).subscribe((res)=>{
        if(res.data){
          this.buildings = res.data[0].building;
        }
    });

    this.documentService.getAllDocuments().subscribe((res)=>{
      res.forEach((value)=>{
        this.documentList.push(value);
      });
      this.documentList.forEach((docu)=>{
        for(var i = 0; i < docu.building.length; i++ ){
          if(this.documentFilterCriteria === 'All Building'){
            docu.show = true;
          }
        }
      });

      this.documentCount = this.documentList.length;

    });

  }

  documentFilter(event, id){
    if(event){
      if(this.buildFilter.indexOf(id) < 0){
        this.buildFilter.push(id)
      }
    }else{
      if(this.buildFilter.indexOf(id) > -1){
        this.buildFilter.splice(this.buildFilter.indexOf(id), 1)
      }
    }
    if(this.buildFilter.length > 0){
      this.documentFilterCriteria = null;
    }else if(this.buildFilter.length === 0 ){
      this.documentFilterCriteria = 'All Building'
    }

    this.documentList.forEach((docu)=>{
      for(var i = 0; i < docu.building.length; i++ ){
        if(this.documentFilterCriteria === 'All Building'){
          docu.show = true;
        }else{
          if(this.buildFilter.indexOf(docu.building[i].id) > -1){
            docu.show = true;
            break;
          }else{
            docu.show = false;
          }
        }
      }
    });
    var documentCount = [];
    this.documentList.forEach((docu, index)=>{
        if(docu.show == true){
          documentCount.push(index);
        }else if(docu.show == false){
          var removeIndex = documentCount.indexOf(index);
          if(removeIndex > -1){
            documentCount.splice(removeIndex, 1);
          }
        }
    });

    this.documentCount = documentCount.length;

  }

  buildingSelect(dropmenu){
    $(dropmenu).toggle();
  }

  fileSelect(fileInput, documentForm){
    $(fileInput).trigger('click');
  }

  openUploadModel(dropMenu, fileInput){
    $(fileInput).val('')
    this.buildingCheckboxState = false;
    this.formState = true;
    this.document.reset();
    this.file = null;
    this.fileName = null;
    this.buildArray = [];
    this.titleError = null;
    this.DescriptionError = null;
    this.titleSpaceError = null;
    this.DescriptionSpaceError = null;
    this.fileError = null;
    this.successMessage = null;
    this.documentId = null;
    this.fileValidError = null;
    this.editedNames='';
    this.buildNameArray =[];
    $(dropMenu).find('input[type="checkbox"]').each(function(index, ele) {
      $(this).prop('checked', false);
    });
    $('#add_group_modal').modal('show');
  }

  clickedItem(value, event){
    if (event === true){
      this.buildArray.push(value.id);
      this.buildNameArray.push((value.buildingName) ? value.buildingName : value.formattedAddress.split(',')[0]);
    }else{
     const index = this.buildArray.indexOf(value.id);
     if (index !== -1){
       this.buildArray.splice(index, 1);
       this.buildNameArray.splice(index, 1);
     }
    }
    this.editedNames =this.buildNameArray.toString();

  }


  fileChange(files){

    this.fileChanged = true;
    this.fileList =  files.target.files;
    if(this.fileList.length > 0) {
      this.file = this.fileList[0];
      this.fileName = this.file.name;

        var Extension = this.file.name.substring(
        this.file.name.lastIndexOf('.') + 1).toLowerCase();

        var file1:File = this.file
        var myReader:FileReader = new FileReader();

        myReader.onloadend = (e) => {
          this.fileToImage = myReader.result;
        }
        myReader.readAsDataURL(file1);


        if (Extension == "pdf" || Extension == "doc" || Extension == "docx") {
          this.fileValidError = null;
          if(this.file.size > 1024 * 1024 * 20){
            alert('Maximum file size should be 20mb')
            this.file = null;
            this.fileName = null;
          }else if(this.file.size <= 1024 * 1024 * 0){
            alert('File is not valid')
            this.file = null;
            this.fileName = null;
          }

        }else{
          this.fileValidError = "Please select either a .pdf, .doc, or .docx file";
          this.file = null;
          this.fileName = null;
        }

    }
  }

  fileUpload(value, valid, dropMenu=null){

    this.titleError = 'Title is required';
    this.DescriptionError = 'Description is required';



    if(this.file == null){
      this.fileError = 'File is required'
    }else{
      this.fileError = null;
    }
    let titleTrim;
    let descriptionTrim;
    if(valid){

    titleTrim = this.document.get('title').value.trim();
    descriptionTrim = this.document.get('description').value.trim();

    if(titleTrim.length == 0){
      this.titleSpaceError = 'Please Enter valid title';
    }else if(titleTrim.length > 0){
      this.titleSpaceError = null;
    }

    if(descriptionTrim.length == 0){
      this.DescriptionError = 'Please Enter valid description';
    }else if(descriptionTrim.length > 0){
      this.DescriptionError = null;
    }
    }

    if(valid && this.file != null && titleTrim.length > 0 && descriptionTrim.length > 0){

      this.document.reset();
      this.titleError = null;
      this.DescriptionError = null;
      value.build = this.buildArray;
      value.file = this.file;
      this.isLoadingActive = true;
      this.documentService.uploadDocument(value, this.formState, this.fileChanged, this.documentId).subscribe(async (res:any)=>{
        if(res){
          this.isLoadingActive = false;
          if(this.formState == true){
           await this.documentService.getDocumentById(res.id).subscribe((res)=>{
              if(this.documentFilterCriteria === 'All Building'){
                res.show = true;
              }else{
                for(var i =0; i < res.building.length; i++){
                  if(this.buildFilter.indexOf(res.building[i].id) > -1){
                    res.show = true;
                    break;
                  }else{
                    res.show = false;
                  }
                 }
              }
              this.documentList.unshift(res);
              var documentCount = [];
              this.documentList.forEach((docu, index)=>{
                if(docu.show == true){
                  documentCount.push(index);
                }else if(docu.show == false){
                  var removeIndex = documentCount.indexOf(index);
                  if(removeIndex > -1){
                    documentCount.splice(removeIndex, 1);
                  }
                }
              });
              this.documentCount = documentCount.length;
            })
          }else if(this.formState == false){
            this.documentService.getDocumentById(res[0].id).subscribe((res)=>{
              if(this.documentFilterCriteria === 'All Building'){
                res.show = true;
              }else{
                for(var i =0; i < res.building.length; i++){
                  if(this.buildFilter.indexOf(res.building[i].id) > -1){
                    res.show = true;
                    break;
                  }else{
                    res.show = false;
                  }
                 }
              }
              this.documentList = this.documentList.map(function(item) { return item.id == res.id ? res : item; });
              this.documentCount = this.documentList.length;
            })
          }


          this.successMessage = 'Document created successfully';
          this.file = null;
          $(dropMenu).find('input[type="checkbox"]').each(function(index, ele) {
            $(this).prop('checked', false);
          });
          setTimeout(()=>{
            this.document.reset();
            $('#add_group_modal').modal('hide');
          }, 2000)
          this.fileChanged = false;
          this.buildingCheckboxState = false;
        }

      })
    }
  }

  deleteDocument(id, name){
    this.deleteButtonDisable = false;
    this.fileToDelete = name;
    this.fileId = id;
    $('#confirmationModal').modal('show');
  }

  fileDestroy(){
    this.deleteButtonDisable = true;
    this.documentService.deleteDocument(this.fileId).subscribe((res)=>{
      $('#confirmationModal').modal('hide');
      this.isUpdated = true
      setTimeout(
        () => {
          this.isUpdated = false;
        }, 3000)
      for(var i = 0; i < this.documentList.length; i++){
        if(this.fileId == this.documentList[i].id){
          this.documentList.splice(i, 1);
        }
      }
      var documentCount = [];
      this.documentList.forEach((docu, index)=>{
        if(docu.show == true){
          documentCount.push(index);
        }else if(docu.show == false){
          var removeIndex = documentCount.indexOf(index);
          if(removeIndex > -1){
            documentCount.splice(removeIndex, 1);
          }
        }
      });
      this.documentCount = documentCount.length;
    });
  }
  modalClose(){
    $('#confirmationModal').modal('hide');
  }

  editDocument(id){
    this.titleError = null;
    this.fileError = null;
    this.titleSpaceError = null;
    this.DescriptionError = null;
    this.buildArray = [];
    this.buildNameArray =[];
    this.editedNames = '';
    this.buildingCheckboxState = true;
    this.successMessage = null;
    $('#add_group_modal').modal('show');
    this.formState = false;
    this.documentId = id;
    this.documentService.getDocumentById(id).subscribe((res)=>{
      this.buildingList = res.building;
      if(res){
        this.document.get('title').patchValue(res.title);
        this.document.get('description').patchValue(res.description);
        this.file = res.files[0];
        this.fileName = res.files[0].filename;
        if(res.building){
          res.building.forEach((build)=>{
            this.buildArray.push(build.id);
            this.buildNameArray.push((build.buildingName) ? build.buildingName : build.formattedAddress.split(',')[0]);
          })
        }
        this.editedNames = this.buildNameArray.toString();

      }
    })

  }

  fileToView(filePath){
    let fileName = filePath.split('/').pop() || '';
    fileName = fileName.split('?')[0]; 

    let extension = fileName.split('.');
    extension = extension.length > 1 ? extension.pop().toLowerCase() : '';

    if (extension === 'pdf') {
      window.open(
        'https://docs.google.com/gview?embedded=true&url=' + encodeURIComponent(filePath),
        '_blank'
      );
    } else if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].indexOf(extension) !== -1) {
      window.open(
        'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(filePath),
        '_blank'
      );
    } else {
      window.open(filePath, '_blank');
    }

    }
  ngOnDestroy(){
    $('#documentModal').modal('hide');
    $('#add_group_modal').modal('hide');
    $('#confirmationModal').modal('hide');
  }
  showAllBuildings() {
    $('#all_building_drp').toggle();
  }
  buildingCheckNames(event, building) {
    this.names = '';
    if (event == true) {
      this.buildingArray.push(building.id);
      this.buildingNames.push((building.buildingName) ? building.buildingName : building.formattedAddress.split(',')[0]);
    } else if (event == false) {
      const index = this.buildingArray.indexOf(building.id);
      if (index !== -1) {
        this.buildingArray.splice(index, 1);
        this.buildingNames.splice(index, 1)
      }
    }
    this.names = this.buildingNames.toString();
  }
}

